 
import elementIntersectionObserver from '../../../dom/elementintersectionobserver';
import { spSelectItem, spViewItemList } from './plpevents';


function getListName() {
    const $header = document.getElementById('h1Title');
    const $search = document.querySelector('h1.searchTerm.h3');
    return $header ? $header.innerText : $search ? $search.innerText.replace(/"/gi, '') : '';
}

export function captureItemSelection() {
    const $list = document.getElementById('product-grid');

    if (!$list) {
        return;
    }

    $list.addEventListener('click', e => {
        const $parent = e.target.closest('[data-item-id]');
        const listName = getListName();

        if ($parent && !/input|label|svg/gi.test(e.target.nodeName)) {
            spSelectItem(listName, {
                ...$parent.dataset
            });
        }
    });
}


export function monitorPLPItemsInView() {
    let scrollListener;
    let observers = [];

    const itemMap = new Map();
    const whenInView = elementIntersectionObserver({ rootMargin: '0px', threshold: 0.5 });
    const listName = getListName();

    const inView = items => {
        if (!items || !items.length) {
            return;
        }

        spViewItemList(listName, items);
    };

    const process = () => {
        itemMap.clear();

        if (observers.length) {
            observers.forEach(observer => observer.disconnect());
            observers = [];
        }

        if (scrollListener) {
            scrollListener.dispose();
        }

        const $list = document.getElementById('product-grid');

        if (!$list) {
            return;
        }

        const $listItems = Array.from($list.querySelectorAll('[data-item-id]'));

        for (const $item of $listItems) {
            if (isElement50PercentInViewport($item)) {
                itemMap.set($item, {
                    ...$item.dataset
                });
                continue;
            }
            break;
        }

        inView([...itemMap.values()]);

        $listItems
            .filter($item => !itemMap.has($item))
            .forEach($item => {
                observers.push(whenInView($item, () => {
                    itemMap.set($item, {
                        ...$item.dataset
                    });
                }));
            });

        itemMap.clear();

        scrollListener = scrollStopEventListener(() => {
            inView([...itemMap.values()]);
            itemMap.clear();
        });
    };

    return {
        refresh: () => process()
    };
}

function scrollStopEventListener(onScrollStop) {
    if (typeof onScrollStop !== 'function') {
        throw new Error('scrollStopEventListener requires a callback function');
    }

    let timer;

    const onScroll = () => {
        if (timer) {
            clearTimeout(timer);
        }

        timer = setTimeout(() => onScrollStop(), 500);
    };

    window.addEventListener('scroll', onScroll);

    return {
        dispose: () => {
            if (timer) {
                clearTimeout(timer);
            }

            window.removeEventListener('scroll', onScroll);
        }
    };
}

function isElement50PercentInViewport(el) {
    var rect = el.getBoundingClientRect();
    var windowHeight = (window.innerHeight || document.documentElement.clientHeight);

    return (
        (rect.top >= 0)
        && ((rect.top + (rect.height / 2)) <= windowHeight)
    );
}
